import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-checkbox',
  styleUrls: ['form-checkbox.component.scss'],
  templateUrl: './form-checkbox.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent],
})
export class FormCheckboxComponent extends FieldBaseComponent {}
